import { realmName, clientID } from "./resourcePath";
import Axios from "axios";

const realm = realmName();
const clID = clientID();
const baseKCURI = `https://accounts.greenyellow.com/auth/admin/realms/${realm}`;

/**
 * Get Keycloak API Promise to retrieve users using email
 * Email search could be full or partial email
 * @param {string} token
 * @param {string} email
 * @returns Keycloak API request promise
 */
export const getUsersUsingEmail = (token, email) => {
	const reqURI = `${baseKCURI}/users?email=${email}`;
	const headers = getHeaders(token);
	const req = Axios.get(reqURI, { headers });

	return req;
};

/**
 * Get Keycloak API Promise to add new users
 * @param {string} token
 * @param {obj} user
 * @returns Keycloak API request promise
 */
export const addUsersToKeycloak = (token, user) => {
	const reqURI = `${baseKCURI}/users`;
	const headers = getHeaders(token);

	const req = Axios.post(reqURI, user, { headers });

	return req;
};

export const updateUsersToKeycloak = (token, user, userKeycloakId) => {
	const reqURI = `${baseKCURI}/users/${userKeycloakId}`;
	const headers = getHeaders(token);

	const req = Axios.put(reqURI, user, { headers });

	return req;
}

export const setRolesToUsers = async (token, id, toSetRoles) => {
	const currentRoles = await getUserRoles(token, id);
	const toAddRoles = toSetRoles.filter(toSetRole => !currentRoles.find(currentRole => currentRole.id === toSetRole.id));
	const toRemoveRoles = currentRoles.filter(currentRole => !toSetRoles.find(toSetRole => toSetRole.id === currentRole.id));
	if(toAddRoles.length)    { await addRolesToUsers(token, id, toAddRoles) }
	if(toRemoveRoles.length) { await removeRolesFromUsers(token, id, toRemoveRoles) }
}

export const getUserRoles = async (token, id) => {
	const reqURI = `${baseKCURI}/users/${id}/role-mappings/clients/${clID}`;
	const headers = getHeaders(token);
	return Axios.get(reqURI, { headers }).then(res => res.data);
}

export const addRolesToUsers = async (token, id, roles) => {
	const reqURI = `${baseKCURI}/users/${id}/role-mappings/clients/${clID}`;
	const headers = getHeaders(token);
	return Axios.post(reqURI, roles, { headers }).then(res => res.data);
};

export const removeRolesFromUsers = async (token, id, roles) => {
	const reqURI = `${baseKCURI}/users/${id}/role-mappings/clients/${clID}`;
	const headers = getHeaders(token);
	return Axios.delete(reqURI, { headers, data: roles }).then(res => res.data);
}

/**
 * Get Keycloak API Promise to get client roles
 * @param {string} token
 * @returns Keycloak API request promise
 */
export const getClientRoles = (token) => {
	const reqURI = `${baseKCURI}/clients/${clID}/roles`;
	const headers = getHeaders(token);

	const req = Axios.get(reqURI, { headers });

	return req;
};

/**
 * Get Keycloak API Promise to delete users from Keycloak
 * @param {string} token
 * @param {string} userID
 * @returns Keycloak API request promise
 */
export const deleteUsersKeycloak = (token, userID) => {
	const reqURI = `${baseKCURI}/users/${userID}`;
	const headers = getHeaders(token);
	const req = Axios.delete(reqURI, { headers });

	return req;
};

export const activateKeycloakUser = (token, userID) => {
	const reqURI = `${baseKCURI}/users/${userID}`;
	const headers = getHeaders(token);
	const req = Axios.put(reqURI, { enabled: true }, { headers });

	return req;
}

export const deactivateKeycloakUser = (token, userID) => {
	const reqURI = `${baseKCURI}/users/${userID}`;
	const headers = getHeaders(token);
	const req = Axios.put(reqURI, { enabled: false }, { headers });

	return req;
}

const getHeaders = (token) => ({
	Authorization: `Bearer ${token}`,
});

export const enumRoles = {
	GY_TH: '_GY:TH',
	GY_VN: '_GY:VN',
	GY_PM: '_GY:PM',
	GY_IT: '_GY:IT',
	GY_Management: '_GY:Management',
	GY_OM: '_GY:O&M',
	GY_General: '_GY:General',
	GY_Accounting: '_GY:Accounting',
	CLIENT_TH: '_CLIENT_TH',
	CLIENT_VN: '_CLIENT_VN'
};